import event, {EVENTS} from '../lib/event';

let vm;

const getVm = () => vm;

event.on(EVENTS.VM_INIT, _vm => {
    console.log('vmInit');
    vm = _vm;
    window.vm = _vm;
});

export {
    getVm
};
